import { createAppSlice } from "@/lib/store/createAppSlice";
import type { PayloadAction } from "@reduxjs/toolkit";
import { toast } from "sonner";
import { getApiBaseUrl } from "@/utils/helpers";
import axios from "axios";

export interface ChatSliceState {
  status: "idle" | "loading" | "failed";
  channelId: string | null;
}

const initialState: ChatSliceState = {
  status: "idle",
  channelId: null,
};

// If you are not using async thunks you can use the standalone `createSlice`.
export const chatSlice = createAppSlice({
  name: "chat",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: (create) => ({
    setChatSliceBits: create.reducer(
      (state, action: PayloadAction<{ bitToSet: keyof ChatSliceState; value: any }>) => {
        const { bitToSet, value } = action.payload;
        // @ts-ignore
        state[bitToSet] = value; // Update the specific bit
      }
    ),
    createChatChannel: create.asyncThunk(
      async (data: { [key: string]: string | number }) => {
        const url = getApiBaseUrl("chat/create-channel", false);
        const response = await axios.post(
          url,
          {
            ...data,
          },
          { headers: { "Content-Type": "application/json", Accept: "application/json" } }
        );
        return response;
      },
      {
        pending: (state) => {
          state.status = "loading";
        },
        fulfilled: (state, action) => {
          state.status = "idle";
          toast.success("Chat channel created successfully!");
          console.log("Chat channel created successfully:", action.payload.data);
        },
        rejected: (state) => {
          state.status = "failed";
          toast.error("Error creating chat channel!");
        },
      }
    ),
  }),
});

export const { setChatSliceBits, createChatChannel } = chatSlice.actions;
export const chatReducer = chatSlice.reducer;
